export class ContactLabelState {
  labelId: string;
  name: string;
  contactIds: string[];
  isSystemLabel: boolean;
  constructor() {
    this.contactIds = [];
  }
}
